import { ethers } from 'ethers'
import { nodeConfigs } from "./config.js";
export async function sendTransaction(from, to, value) {
    if (!window.ethereum) {
        Vue.prototype.$showErrorMessage("当前环境未安装钱包")
    }
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    if (provider) {
        const transaction = {
            to: to,
            value: ethers.utils.parseEther(value), // 发送的以太币数量
        };
        // try {
        const tx = await signer.sendTransaction(transaction);
        console.log('交易已发送', tx);
        // const data = await tx.wait()
        // console.log("交易已完成=",data)
        return tx;
        // } catch (error) {
        //     console.error('交易发送失败', error.message);
        //     var str = error.message
        //     if(str.length>150){
        //         str = str.substr(0,150)+"......"
        //     }
        //     return error;
        // }
    } else {
        console.error('未连接到小狐狸钱包');
        return null;
    }
}
export async function deployContract(abi, code, arr1, arr2, arr3, arr4) {
    console.log(arr1)
    console.log(arr2)
    console.log(arr3)
    console.log(arr4)
    if (!window.ethereum) {
        Vue.prototype.$showErrorMessage("当前环境未安装钱包")
    }
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    if (provider) {
        const factory = new ethers.ContractFactory(abi, code, signer);
        try {
            const contract = await factory.deploy(arr1, arr2, arr3, arr4);
            console.log('factory已部署', contract);
            // await contract.deployed();
            // console.log('合约已部署', contract.address);
            return contract;
        } catch (error) {
            Vue.prototype.$showErrorMessage(error)
            // console.error('交易发送失败', error.message);
            // var str = error.message
            // if(str.length>100){
            //     str = str.substr(0,100)+"......"
            // }
            // return str;
        }
    } else {
        console.error('无法连接到提供方');
        return null;
    }
}
export async function getPredictContractAddr(address) {
    if (!window.ethereum) {
        Vue.prototype.$showErrorMessage("当前环境未安装钱包")
    }
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    var nonce = await provider.getTransactionCount(address);
    console.log('nonce=', nonce);
    const predictedContractAddress = ethers.utils.getContractAddress({
        from: address,
        nonce: nonce,
    });
    console.log('Predicted contract address:', predictedContractAddress);
    return predictedContractAddress
}
export function getGasConfig(contractModeCode) {
    // console.log("getGasConfig")
    var data = JSON.parse(localStorage.getItem("TokenBox-gas"))
    console.log("GasConfig =", data)
    var chainId = localStorage.getItem("TokenBox-chainID")
    var res = []
    if (data && data.length > 0) {
        res = data.filter(item => item.chainId == chainId && item.code == contractModeCode)
        console.log("filter =", chainId, contractModeCode)
        if (res && res.length > 0) {
            console.log("filterGas =", res[0].price)
            return res[0]
        }
    }
    return null
}
export function getChainConfig(chainId) {
    // console.log("getChainConfig")
    var data = nodeConfigs
    if (!chainId) {
        var chainId = localStorage.getItem("TokenBox-chainID")
    }
    console.log("getChainConfig =", data, chainId)
    var res = []
    if (data && data.length > 0) {
        res = data.filter(item => item.chainId == chainId)
        if (res && res.length > 0) {
            console.log("filterConfig =", res[0])
            return res[0]
        }
    }
    return null
}
export default {
    // getChainConfig
}
import Vue from 'vue';
Vue.prototype.$getChainConfig = getChainConfig;
Vue.prototype.$getGasConfig = getGasConfig;